/** Raw list from product (Antifox / opps chat emoji step). Dedup preserves first occurrence. */
const OPPS_EMOJI_LIBRARY_RAW = [
  '💩',
  '😌',
  '🙄',
  '👀',
  '🤭',
  '😏',
  '🫠',
  '😵‍💫',
  '😶‍🌫️',
  '🫣',
  '😼',
  '😗✌️',
  '😮‍💨',
  '🫨',
  '💅',
  '🤌😒',
  '🗑️',
  '🧹',
  '🧻',
  '🫧',
  '🧟‍♀️',
  '🧟‍♂️',
  '🫥',
  '🍄',
  '🪳',
  '🐛',
  '🪱',
  '💀',
  '🌀',
  '🤡',
  '🫦',
  '🤢',
  '🤮',
  '🙃',
  '👉',
  '🫵',
  '😤',
  '😭',
  '🐜',
  '🕷️',
  '🕸️',
  '🦂',
  '🐌',
  '🐍',
  '🐢',
  '🦗',
  '🍂',
  '🍁',
  '🪨',
  '👃',
  '😵',
  '😖',
  '😫',
  '🤯',
];

function dedupeOrdered(strings) {
  const seen = new Set();
  const out = [];
  for (const s of strings) {
    const key = typeof s === 'string' ? s.trim() : '';
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(key);
  }
  return out;
}

/**
 * Emoji tiles exclusive to Antifox / “opps” collage flow ordered for pagination (9 per screen, then MORE).
 */
export const OPPS_EMOJI_LIBRARY = dedupeOrdered(OPPS_EMOJI_LIBRARY_RAW);

/**
 * @param {number} startIndex inclusive index into {@link OPPS_EMOJI_LIBRARY}
 * @param {number} count max length (typically 9)
 */
export function getNextOppsEmojiBatch(startIndex, count = 9) {
  const n = OPPS_EMOJI_LIBRARY.length;
  if (!Number.isFinite(startIndex) || startIndex >= n || count <= 0) return [];
  const end = Math.min(n, startIndex + count);
  return OPPS_EMOJI_LIBRARY.slice(startIndex, end);
}
